export default __webpack_public_path__ + "static/media/track.28c24482.svg";